import { type CoreStore } from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Get store details from logged user.
 *
 * @endpoint GET /api/saas/me/store
 * @scope saas
 */
export async function getStoreDetails(): Promise<CoreStore> {
  const response = await api.get('/api/saas/me/store')

  return response.data?.store ?? null
}
